export const init = async function() {
    document.addEventListener('DOMContentLoaded', function() {
        // Get all links with class "intercept-link"
        const removeFromCartLinks = document.querySelectorAll('[data-action="minus"]:not(.js-gift-box-quantity-minus)');
        const addToCartLinks = document.querySelectorAll('[data-action="plus"]:not(.js-gift-box-quantity-plus)');
        const isCartPage = document.body.getAttribute('data-shopify-template') === 'cart';
        const eventSource = isCartPage ? 'cart_page' : 'mini_cart';
        // Loop through each link and add an event listener
        addToCartLinks.forEach((link)=>{
            link.addEventListener('click', (event)=>{
                // Prevent the default link behavior
                event.preventDefault();
                const productTitle = link.getAttribute('data-product-title');
                const productSku = link.getAttribute('data-product-sku');
                const variantTitle = link.getAttribute('data-variant-name');
                const price = link.getAttribute('data-product-price');
                const productType = link.getAttribute('data-product-type');
                Shopify.analytics.publish('add_to_cart', {
                    event: 'Add to Cart',
                    productsToAdd: [
                        {
                            sku: productSku,
                            name: productTitle,
                            variantName: variantTitle,
                            price: price,
                            quantity: 1,
                            productType: productType
                        }
                    ],
                    source: eventSource
                });
                const href = link.getAttribute('href');
                if (href) {
                    window.location.href = href;
                }
            });
        });
        removeFromCartLinks.forEach((link)=>{
            link.addEventListener('click', (event)=>{
                // Prevent the default link behavior
                event.preventDefault();
                const productTitle = link.getAttribute('data-product-title');
                const productSku = link.getAttribute('data-product-sku');
                const variantTitle = link.getAttribute('data-variant-name');
                const price = link.getAttribute('data-product-price');
                const productType = link.getAttribute('data-product-type');
                Shopify.analytics.publish('remove_from_cart', {
                    event: 'Remove from Cart',
                    productsToRemove: [
                        {
                            sku: productSku,
                            name: productTitle,
                            variantName: variantTitle,
                            price: price,
                            quantity: 1,
                            productType: productType
                        }
                    ],
                    source: eventSource
                });
                const href = link.getAttribute('href');
                if (href) {
                    window.location.href = href;
                }
            });
        });
    });
};
